import * as actions from "../actions/actions";
import React from "react";
import { connect } from "react-redux";
import ColorPicker from "./nounproject-color-picker";

class ColorSelection extends React.Component {
    addColorBorder(color) {
        // Check if color needs border
        let r, g, b, brightness;
        if ("#" == color.hex[0] && 7 == color.hex.length) {
            r = parseInt(color.hex.slice(1, 3), 16);
            g = parseInt(color.hex.slice(3, 5), 16);
            b = parseInt(color.hex.slice(5, 7), 16);
        } else if ("#" == color.hex[0] && 4 == color.hex.length) {
            r = parseInt(color.hex[1] + color.hex[1], 16);
            g = parseInt(color.hex[2] + color.hex[2], 16);
            b = parseInt(color.hex[3] + color.hex[3], 16);
        }

        brightness = (r + r + b + g + g + g) / 6;

        if (brightness > 200) {
            return "light-color";
        } else {
            return "";
        }
    }

    componentDidMount() {
        let colorPalette;

        if (this.props.icon !== undefined) {
            if (!this.props.colorPalette) {
                colorPalette = {
                    customColors: [
                        { hex: "#EC5D57" },
                        { hex: "#F38F19" },
                        { hex: "#F5D327" },
                        { hex: "#70C041" },
                        { hex: "#51A7F9" },
                        { hex: "#B36AE2" },
                        { hex: "#000000" },
                        { hex: "#ffffff" }
                    ],
                    selectedColor: { hex: "black" }
                };
            } else {
                colorPalette = {
                    customColors: this.props.colorPalette,
                    selectedColor: this.props.selectedColor
                };
            }
            this.props.setColor(colorPalette);
        }
    }

    colorSwatchSelected(color) {
        this.setColor(color);
        //this.showColorOptions();
    }

    constructor(props) {
        super(props);

        this.state = {
            showColorOptions: false
        };
    }

    hideOptions() {
        let newColorPalette = Object.assign([], this.props.colorPalette),
            newColor = true,
            newSelectedColor = this.props.selectedColor;

        // we need to make sure we have a new color or not before we add it to the costumColor list when the picker is dismissed
        if (
            newSelectedColor.hex === "Black" ||
            newSelectedColor.hex === "White" ||
            newSelectedColor.hex.toUpperCase() === "#FFFFFF" ||
            newSelectedColor.hex === "#000000"
        ) {
            newColor = false;
        }
        newColorPalette.forEach(customColor => {
            if (customColor.hex === newSelectedColor.hex) {
                newColor = false;
            }
        });
        if (newColor) {
            newColorPalette.push({
                hex: this.props.selectedColor.hex
            });
            newColorPalette = newColorPalette.slice(-6);

            this.props.setColor({
                customColors: newColorPalette,
                selectedColor: this.props.selectedColor
            });
        }

        this.setState({
            showColorOptions: false,
            showSizeOptions: false,
            showColorChoose: false
        });
    }

    render() {
        let hideOptionsDom;

        if (
            this.state.showSizeOptions ||
            this.state.showColorOptions ||
            this.state.showColorChoose
        ) {
            hideOptionsDom = (
                <div
                    className="hideOptionsDom"
                    onClick={this.hideOptions.bind(this)}
                    style={{
                        position: "fixed",
                        width: "100%",
                        height: "100%",
                        display: "block",
                        zIndex: "8",
                        top: "0",
                        left: "0"
                    }}
                />
            );
        }

        if (this.props.activeIcon !== undefined) {
            let colorSelectionUI,
                colorSwatches = this.renderColorSwatches(),
                colorUI;

            if (this.state.showColorOptions || this.state.showColorChoose) {
                if (this.state.showColorOptions) {
                    colorSelectionUI = this.renderColorOptions();
                } else if (this.state.showColorChoose) {
                    colorSelectionUI = this.renderColorChoose();
                }

                colorUI = (
                    <div className="hero-color-picker">
                        <div className="user-colors">{colorSwatches}</div>
                        {colorSelectionUI}
                    </div>
                );
            } else {
                colorUI = (
                    <div className="hero-color-picker">
                        <div className="user-colors">{colorSwatches}</div>
                    </div>
                );
            }

            return (
                <div className="plugin-select-box plugin-select-color">
                    {hideOptionsDom}
                    {colorUI}
                    <style>{`
                                                    
                            .color-swatch{
                                width: 14px;
                                height: 14px;
                                margin-right: 8px;
                                background: black;
                                display: inline-block;
                            }
                            .selected-color{
                                padding-left: 24px;
                            }
                            .selected-color .color-swatch{
                                width: 23px;
                                height: 23px;
                                position: absolute;
                                top: 0;
                                left: 0;
                            }
                            #custom-color-picker{
                                position: absolute;
                                right: 0;
                                bottom: 0;
                                z-index: 9;
                                background: #FFFFFF;
                                border: solid 3px #F2F2F2;
                                display: flex;
                                align-items: flex-start;
                                justify-content: flex-start;
                                width: 306px;
                            }
                            .color-picker-pointer-hue{
                                width: 24px;
                                height: 4px;
                                border: solid 1px #000;
                                box-shadow: 0 0 0 1px #fff;
                                transform: translate(-2px, -2px);
                                transition: 0.3s ease-out;
                                transition-property: height, width, transform;
                                z-index: 8;
                                position: relative;
                            }
                            #hue:hover .color-picker-pointer-hue{
                                width: 36px;
                                height: 24px;
                                transform: translate(-8px, -12px);
                                z-index: 10;
                            }
                            .custom-color-inputs{
                                width: 100%;
                                max-width: 80px;
                            }
                            .color-picker-pointer-circle{
                                width: 12px;
                                height: 12px;
                                border-radius: 50%;
                                border: solid 1px #000;
                                box-shadow: 0 0 0 1px #fff;
                                transform: translate(-6px, -6px);
                                transition: 0.3s ease-out;
                                transition-property: height, width, transform;
                                z-index: 9;
                                position: relative;
                            }
                            #Saturation:hover .color-picker-pointer-circle{
                                width: 48px;
                                height: 48px;
                                transform: translate(-24px, -24px);
                            }
                            #hue,
                            #Saturation{
                                flex-shrink: 0;
                            }
                            #custom-color-picker label{
                                position: absolute;
                                padding: 2px 4px;
                                color: #6D6D6D;
                            }
                            #custom-color-picker input{
                                width: 100%;
                                min-width: 90px;
                                padding: 2px 4px 2px 18px;
                                background: #ffffff;
                                border: solid 1px #F2F2F2;
                            }
                            .color-box-group{
                                padding: 4px;
                            }
                            @media only screen and (max-width: 350px) {
                                .icon-editing{
                                    flex-direction: column;
                                }
                                .plugin-select-size{
                                    margin: 0;
                                }
                                #custom-color-picker{
                                    width: auto;
                                    flex-direction: column;
                                }
                                .custom-color-inputs{
                                    max-width: 350px;
                                }
                            }
                            @media only screen and (max-width: 250px) {
                                .the-icon-container{
                                    min-height: 430px;
                                }
                                #custom-color-picker{
                                    max-width: 150px;
                                }
                                #Saturation{
                                    width: 120px !important;
                                    height: 120px !important;
                                }
                                #hue{
                                    height: 120px !important;
                                }
                            }
                        `}</style>
                </div>
            );
        } else {
            return null;
        }
    }

    renderColorChoose() {
        if (this.state.showColorChoose) {
            return (
                <ColorPicker
                    color={this.props.selectedColor}
                    store={this.props.store}
                    onChange={this.handleColorChange}
                    setColor={this.setColorPickerColor}
                />
            );
        }
    }

    setColorPickerColor = newCustomColor => {
        this.props.setColor(newCustomColor);
    };

    handleColorChange = color => {

    };

    renderColorOptions() {
        if (this.state.showColorOptions) {
            let colorKey = 0,
                options = [];

            this.props.colorPalette.forEach(color => {
                colorKey = colorKey + 1;
                options.push(
                    <li
                        className={
                            this.props.selectedColor.hex === color.hex
                                ? "selected"
                                : ""
                        }
                        key={`${colorKey}-${color.hex}`}
                        onClick={this.setColor.bind(this, color.hex)}
                    >
                        <span
                            className="color-swatch"
                            style={{ backgroundColor: `${color.hex}` }}
                        />
                        {color.hex}
                    </li>
                );
            });

            return (
                <ul className="plugin-select-box-options">
                    {options.reverse()}
                    <li
                        className={
                            this.props.selectedColor.hex === "White"
                                ? "selected"
                                : ""
                        }
                        onClick={this.setColor.bind(this, "White")}
                    >
                        <span
                            className="color-swatch"
                            style={{ backgroundColor: "white" }}
                        />
                        {"White"}
                    </li>
                    <li
                        className={
                            !this.props.selectedColor ||
                            this.props.selectedColor.hex === "Black"
                                ? "selected"
                                : ""
                        }
                        onClick={this.setColor.bind(this, "Black")}
                    >
                        <span
                            className="color-swatch"
                            style={{ backgroundColor: "black" }}
                        />
                        {"Black"}
                    </li>
                    <li onClick={this.showColorChoose.bind(this)}>
                        Custom Color
                    </li>
                </ul>
            );
        }
    }

    renderColorSwatches() {
        let colorSwatches = [],
            defaultColors = [{ hex: "#000000" }, { hex: "#ffffff" }],
            key = 0;

        defaultColors.forEach(color => {
            let colorName;
            if (color.hex === "#000000") {
                colorName = "Black";
            }
            if (color.hex.toUpperCase() === "#FFFFFF") {
                colorName = "White";
            }
            this.addColorBorder(color);
            colorSwatches.push(
                <div
                    key={key}
                    title={`Change color to ${color.hex}`}
                    className={`default-color color ${this.addColorBorder(
                        color
                    )}`}
                    style={{ backgroundColor: `${color.hex}` }}
                    onClick={this.colorSwatchSelected.bind(this, color.hex)}
                >
                    <div className="color-swatch-tip">{colorName}</div>
                </div>
            );
            key = key + 1;
        });

        this.props.colorPalette.forEach(color => {
            colorSwatches.push(
                <div
                    key={key}
                    title={`Change color to ${color.hex}`}
                    className={`color ${this.addColorBorder(color)}`}
                    style={{ backgroundColor: `${color.hex}` }}
                    onClick={this.colorSwatchSelected.bind(
                        this,
                        `${color.hex}`
                    )}
                >
                    <div className="color-swatch-tip">
                        {color.hex.toUpperCase()}
                    </div>
                </div>
            );
            key = key + 1;
        });

        colorSwatches.push(
            <div
                key="key-custom-color"
                title="Change color to a custom color"
                className={`color ui_plus`}
                style={{ backgroundColor: "#BABABA" }}
                onClick={this.showColorChoose.bind(this)}
            >
                <div className="color-swatch-tip">New&nbsp;color</div>
            </div>
        );

        return colorSwatches;
    }

    setColor(hex, e) {
        let activeColor,
            colorPalette = {};
        // colorPalette = Object.assign([], this.state.colorPalette);
        colorPalette.customColors = Object.assign([], this.props.colorPalette);

        if (hex === "#000000" || hex === "#ffffff") {
            colorPalette.selectedColor = { hex: hex };
        } else {
            this.props.colorPalette.forEach(customColor => {
                if (customColor.hex === hex) {
                    colorPalette.selectedColor = { hex: hex };
                }
            });
        }

        this.setState({
            colorPalette: colorPalette,
            selectedColor: this.props.selectedColor
        });

        this.props.setColor(colorPalette);
    }

    showColorChoose() {
        this.setState({
            showColorOptions: false,
            showColorChoose: true
        });
    }

    showColorOptions() {
        if (!this.state.showColorOptions) {
            this.setState({
                showColorOptions: true
            });
        }
    }
}

function mapStateToProps(state, ownProps) {
    let apiResponse = state.apiResponse,
        activeIcon,
        colorPalette,
        selectedColor,
        customColorSelected;

    if (state.icons.colorPalette) {
        activeIcon = ownProps.icon;
        colorPalette = state.icons.colorPalette;
        if (state.icons.selectedColor) {
            selectedColor = state.icons.selectedColor;
            if (state.icons.selectedColor.hex !== "black") {
                customColorSelected = true;
            } else {
                customColorSelected = false;
            }
        }
    }

    return {
        apiResponse,
        activeIcon,
        colorPalette,
        customColorSelected,
        selectedColor
    };
}

module.exports = connect(mapStateToProps, {
    setColor: actions.setColor
})(ColorSelection);
